import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Typography,
} from "@material-ui/core";

import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";
import LinkInText from "src/shared_modules/veu-visitors-core/components/common/link-in-text";

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

class PopoverAccessDenied extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        this.props.hidePopover("AccessDenied");
    }


    renderContent() {
        return(<React.Fragment>
                    <Typography variant="h4" component="h1" color="primary">
                        <Translate>popovers.accessDenied.title</Translate>
                    </Typography>
                    <br />
                    <Typography variant="body1" component="div" color="primary">
                        <LinkInText isI18n  label="popovers.accessDenied.message" />
                    </Typography>
            </React.Fragment>);
    }


    render() {
        if( !this.props.showAccessDenied )
            return(null);

        return (<FloatingContainer position="center"
                        width="sm"
                        fsSwitch="sm"
                        className="user"
                        modal
                        onClickAway={ this.handleClose}
                        onCloseButton={ this.handleClose }
                        largeBottomPadding={this.props.event.hasUserlike}
                    >
                    { this.renderContent() }
            </FloatingContainer>);
    }
}

PopoverAccessDenied.propTypes = {
    showAccessDenied: PropTypes.bool,
    event: PropTypes.object,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        showAccessDenied : state.popovers.showAccessDenied,
        event: state.event,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PopoverAccessDenied);
